import { useLayoutEffect } from 'react'

import GoogleAnalytics from 'services/analytics/google'
import FacebookPixel from 'services/analytics/facebook_pixel'
import { useGetFeaturesQuery } from 'root-api'

import { useOrganizationUuid } from './use_organization'

const RenderPublisherTracker = ({
  ga4MeasurementId,
  facebookPixelTrackingCode
}) => {
  useLayoutEffect(() => {
    if (ga4MeasurementId) {
      GoogleAnalytics.configureGA4(ga4MeasurementId)
    }
  }, [ga4MeasurementId])

  useLayoutEffect(() => {
    if (facebookPixelTrackingCode) {
      FacebookPixel.init(facebookPixelTrackingCode)
      FacebookPixel.pageView()
    }
  }, [facebookPixelTrackingCode])

  return null
}

export default () => {
  const uuid = useOrganizationUuid()
  const { data } = useGetFeaturesQuery({ uuid }, { skip: !uuid })

  if (!data) return null

  return (
    <RenderPublisherTracker
      ga4MeasurementId={data.google_analytics_4_measurement_id}
      facebookPixelTrackingCode={data.facebook_pixel_tracking_code}
    />
  )
}
